module.exports = __webpack_public_path__ + "img/Andaluza-18-min.79481a12.jpg";